module.exports = __webpack_public_path__ + "img/modalSvg.580d6665.svg";